import { create } from "zustand";
import { persist } from "zustand/middleware";

const tenantChangeListeners = new Set();

export function subscribeTenantChange(listener) {
  if (typeof listener !== "function") return () => { };
  tenantChangeListeners.add(listener);
  return () => {
    tenantChangeListeners.delete(listener);
  };
}

export const useTenantStore = create(
  persist(
    (set, get) => ({
      selectedTenantId: null,

      /**
       * @param {string|null|undefined} tenantId
       * @param {{ fromBroadcast?: boolean }} [meta] — when fromBroadcast, listeners run
       *   (domain refetch / reference reset) but must not re-broadcast tenant_reset.
       */
      setSelectedTenantId: (tenantId, meta = {}) => {
        const nextTenantId = tenantId || null;
        const prevTenantId = get().selectedTenantId;
        if (prevTenantId === nextTenantId) return;
        set({ selectedTenantId: nextTenantId });
        const changeMeta = { fromBroadcast: Boolean(meta?.fromBroadcast) };
        tenantChangeListeners.forEach((fn) => fn(nextTenantId, prevTenantId, changeMeta));
      },

      initializeFromUser: (user) => {
        const memberships = user?.memberships;
        if (!Array.isArray(memberships) || memberships.length === 0) {
          get().setSelectedTenantId(null);
          return;
        }

        const current = get().selectedTenantId;
        const isValid = current && memberships.some((m) => {
          const tId = m?.tenant?.id || m?.tenant?._id || m?.tenant;
          return tId === current;
        });
        if (isValid) return;

        const firstTenantId = memberships[0]?.tenant?.id || memberships[0]?.tenant?._id || memberships[0]?.tenant || null;
        get().setSelectedTenantId(firstTenantId);
      },

      reset: () => get().setSelectedTenantId(null),
    }),
    {
      name: "tenant-storage",
      partialize: (state) => ({ selectedTenantId: state.selectedTenantId }),
    },
  ),
);
